// extracted by mini-css-extract-plugin
module.exports = {"btn":"_27XOsSK9ii_TrIcNnexurn"};